/**
 * Shell Application - PageLoader Component
 * Project: Quantiix Shell (quantiix-shell)
 * Module: src/components/PageLoader.jsx
 *
 * Full-page or inline loading indicator with optional message
 */

import React from 'react';
import { CustomLoader } from '@quantiix/design-system';
import styles from './PageLoader.module.css';

export const PageLoader = React.memo(function PageLoader({
                                                             message = null,
                                                             fullPage = true,
                                                             transparent = false
                                                         }) {
    return (
        <div className={fullPage ? styles.fullPage : styles.inline}>
            <CustomLoader loading={true} transparent={transparent}>
                <div className={styles.loaderContent}>
                    {message && <span className={styles.message}>{message}</span>}
                </div>
            </CustomLoader>
        </div>
    );
});